import { observer } from "mobx-react-lite";
import "./CaseSearch.scss";
import React, { useEffect, useState } from "react";
import caseStore from "../../stores/CaseStore";
import {
  Alert,
  CircularProgress,
  MenuItem,
  Select,
  TablePagination,
} from "@mui/material";
import { Case, CaseOrderBy, CaseStatus } from "../../stores/CaseStore/types";
import CaseItem from "../../components/Cases/CaseItem";
import useTranslation from "../../hooks/useTranslation";
import { useParams } from "react-router-dom";
import { UserRoles } from "../../stores/AuthStore/types";

const CaseSearch = observer(() => {
  const { t } = useTranslation();
  const { role } = useParams<{ role: string | undefined }>();
  const [loading, setLoading] = useState(false);
  const [cases, setCases] = useState<Case[]>([]);
  const [count, setCount] = useState<number>(0);
  const [orderBy, setOrderBy] = useState<CaseOrderBy>(
    CaseOrderBy.CREATE_DATE_DESC
  );
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(20);
  /*
  const [filters, setFilters] = useState({
    budget: "-",
    caseType: "-",
    caseCity: "-",
    userCity: "-",
  });
   */

  useEffect(() => {
    doSearch();
  }, [caseStore.searchKeyword, orderBy, page, rowsPerPage]);

  const doSearch = () => {
    setLoading(true);

    caseStore
      .searchCases(
        orderBy,
        page,
        rowsPerPage,
        CaseStatus.ACTIVE,
        role as UserRoles
      )
      .then((result) => {
        setCases(result.cases);
        setCount(result.count);

        if (role === UserRoles.USER) {
          caseStore.caseSearchResult = result.cases.slice(0, 4);
        } else if (role === UserRoles.LAWYER) {
          caseStore.delegationSearchResult = result.cases.slice(0, 4);
        }
      })
      .finally(() => setLoading(false));
  };

  const handleSortChange = (orderBy: CaseOrderBy) => {
    setOrderBy(orderBy);
  };

  const handleChangePage = (
    event: React.MouseEvent<HTMLButtonElement> | null,
    newPage: number
  ) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  /*
  const handleUserCityChange = (value: string) => {
    setFilters((prev) => ({
      ...prev,
      userCity: value,
    }));
  };

  const handleCaseCityChange = (value: string) => {
    setFilters((prev) => ({
      ...prev,
      caseCity: value,
    }));
  };
   */

  return (
    <div className="caseSearchContainer">
      {loading && <CircularProgress size={"32px"} />}

      {!loading && cases.length === 0 && (
        <Alert severity={"warning"}>{t("no-search-result")}</Alert>
      )}

      {!loading && cases.length > 0 && (
        <div className="filters">
          <div />
          {/*
            <div className="filterBy">
              <h4>{t('filter-by')} <i className="fal fa-sort-up"/></h4>
              <div className='filter-content'>
                  <section className='filter-case-city mb'>
                      <InputLabel id="case-city-label" className='mb'>{t('case-city')}</InputLabel>
                      <Select
                          onChange={(e) => handleCaseCityChange(`${e.target.value}`)}
                          value={filters.caseCity}
                          labelId="case-city-label"
                      >
                          <MenuItem key={'-'} value={'-'}>{t('please-select-case-city')}</MenuItem>
                          {Object.keys(cityMap).map((cityCode) => (
                              <MenuItem key={cityCode} value={cityCode}>{cityMap[cityCode]}</MenuItem>
                          ))}
                      </Select>
                  </section>
                  <section className='filter-user-city'>
                      <InputLabel id="user-city-label" className={'mb'}>{t('user-city')}</InputLabel>
                      <Select
                          labelId="user-city-label"
                          value={filters.userCity}
                          onChange={(e) => handleUserCityChange(`${e.target.value}`)}
                      >
                          <MenuItem key={'-'} value={'-'}>{t('please-select-user-city')}</MenuItem>
                          {Object.keys(cityMap).map((cityCode) => (
                              <MenuItem key={cityCode} value={cityCode}>{cityMap[cityCode]}</MenuItem>
                          ))}
                      </Select>
                  </section>
              </div>
          </div> */}
          <div className="sortBy">
            <h4>
              <i className="fal fa-sort-amount-down" /> {t("order-by")}:
            </h4>
            <Select
              onChange={(e) => handleSortChange(e.target.value as CaseOrderBy)}
              value={orderBy}
              size={"small"}
            >
              {Object.values(CaseOrderBy).map((orderBy) => (
                <MenuItem key={orderBy} value={orderBy}>
                  {t(orderBy)}
                </MenuItem>
              ))}
            </Select>
          </div>
        </div>
      )}

      {!loading && (
        <>
          <div className="caseList">
            {cases.map((caseItem) => (
              <CaseItem key={caseItem.id} caseItem={caseItem} />
            ))}
          </div>
          <TablePagination
            rowsPerPageOptions={[20, 40, 60, 80, 100]}
            labelRowsPerPage={t("rows-per-page")}
            component="div"
            count={count}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </>
      )}
    </div>
  );
});

export default CaseSearch;
